interface Config {
  agentReportingUrl: string
  attributionUrl: string
  baseUrl: string
  bulkActionURL: string
  bulkReqURL: string
  cdnURL: string
  chatWidgetDeploymentUrl: string
  cloudFunctionsUrl: string
  cnameRedirectURL: string
  cnameWhitelabelURL: string
  conversationsReportingServiceUrl: string
  conversationsServiceUrl: string
  deepLinkUrl: string
  dialogflowEngagementsBaseUrl: string
  emailReportingUrl: string
  emailsServiceUrl: string
  formEmbedUrl: string
  formsApiUrl: string
  formsApiUrlV1: string
  frontEndCNameRedirectURL: string
  funnelsApiURL?: string
  funnelServiceBaseUrl: string
  ghlRevexBackendUrl: string
  humanRollOverServiceBaseUrl: string
  isvServiceBaseUrl: string
  localizationApiURL: string
  globalSearchApiURL: string
  membershipUrl: string
  communitiesUrl: string
  membershipAppUrl: string
  newBaseUrl: string
  newMembershipUrl: string
  oldBaseUrl: string
  opportunityReportingService: string
  paymentsApiURL?: string
  dataBridgeApiUrl: string
  paymentServiceBaseUrl: string
  phoneCallReportingService: string
  productsApiURL?: string
  publicApiUrl: string
  pythonBaseUrl: string
  reputation: {
    apiUrl: string
  }
  requestLoggerApiURL?: string
  resellingBaseUrl: string
  reserveServiceBaseUrl: string
  restApiUrl: string
  saasServiceBaseUrl: string
  bladePlatformBaseUrl:string
  shortenUrlServiceUrl: string
  smtpServiceUrl: string
  snapshotServiceUrl: string
  snapshotsRevexUrl: string
  statsApiURL: string
  surveysApiUrl: string
  wordpress: {
    apiUrl: string
  }
  mediaServiceUrl: string
}

const apiUrls = {
  nik: 'https://nik-dot-highlevel-staging.appspot.com',
  abhishek: 'https://abhishek-dot-highlevel-staging.uc.r.appspot.com',
  upamanyu: 'https://upamanyu-dot-highlevel-staging.uc.r.appspot.com',
}

const override: Boolean = process?.env?.VUE_APP_DB_OVERRIDE === 'true'

const config: { [key: string]: Config } = {
  development: {
    agentReportingUrl: 'https://backend.leadconnectorhq.com',
    attributionUrl: 'https://backend.leadconnectorhq.com/attribution_service',
    baseUrl: 'https://highlevel-staging.appspot.com',
    bulkActionURL: 'https://staging.services.leadconnectorhq.com/bulk-actions',
    bulkReqURL: 'https://bulk-request-dot-highlevel-staging.uc.r.appspot.com',
    cacheInvalidateUrl: 'https://backend.leadconnectorhq.com/cache/clear',
    cdnURL: 'https://staging.filesafe.space/',
    chatWidgetDeploymentUrl: 'https://storage.googleapis.com/staging-leadconnector/',
    cloudFunctionsUrl: 'https://us-central1-highlevel-staging.cloudfunctions.net',
    cnameRedirectURL: 'flash-funnel-staging.msgsndr.com',
    cnameWhitelabelURL: 'link.msgsndr.com',
    conversationsReportingServiceUrl: 'https://staging.backend.leadconnectorhq.com/conversations-reporting',
    conversationsServiceUrl: 'https://staging.backend.leadconnectorhq.com/conversations',
    deepLinkUrl: 'https://deep-link-dot-highlevel-staging.uc.r.appspot.com',
    dialogflowEngagementsBaseUrl: 'https://backend.leadconnectorhq.com/dialogflow-engagement',
    emailReportingUrl: 'https://backend.leadconnectorhq.com',
    emailsServiceUrl: 'http://localhost:5076/emails',
    formEmbedUrl: 'https://staging.link.gohighlevel.com/js',
    formsApiUrl: 'http://localhost:5070',
    formsApiUrlV1: 'https://stagingrest.gohighlevel.com',
    frontEndCNameRedirectURL: 'staging.msgsndr.com',
    funnelsApiURL: 'https://staging.backend.leadconnectorhq.com',
    funnelServiceBaseUrl: 'https://backend.leadconnectorhq.com/funnel_backend',
    ghlRevexBackendUrl: 'https://staging.backend.leadconnectorhq.com/phone-system',
    humanRollOverServiceBaseUrl: 'https://backend.leadconnectorhq.com/eliza',
    isvServiceBaseUrl: 'https://backend.leadconnectorhq.com/isv_service', // production saas URL
    localizationApiURL: 'https://staging.backend.leadconnectorhq.com/localization',
    globalSearchApiURL: 'https://staging.backend.leadconnectorhq.com/global-search',
    membershipUrl: 'https://backend.leadconnectorhq.com/membership',
    communitiesUrl: 'https://staging.backend.leadconnectorhq.com/communities',
    membershipAppUrl: "http://localhost:4000",
    newBaseUrl: 'https://staging.backend.leadconnectorhq.com/appengine',
    newMembershipUrl: 'https://backend.leadconnectorhq.com/membership',
    oldBaseUrl: 'https://staging.services.leadconnectorhq.com/appengine',
    opportunityReportingService: 'https://backend.leadconnectorhq.com/reporting/opportunities',
    paymentsApiURL: 'https://staging.backend.leadconnectorhq.com',
    paymentServiceBaseUrl: 'https://staging.backend.leadconnectorhq.com/payment_service',
    phoneCallReportingService: 'https://backend.leadconnectorhq.com/phone_call_reporting',
    productsApiURL: 'https://staging.backend.leadconnectorhq.com',
    publicApiUrl: 'https://public-api-dot-highlevel-staging.uc.r.appspot.com',
    pythonBaseUrl: 'https://python-backend-dot-highlevel-backend.appspot.com',
    reputation: {
      apiUrl: 'https://staging.backend.leadconnectorhq.com/reputation',
    },
    requestLoggerApiURL: 'https://staging.backend.leadconnectorhq.com',
    resellingBaseUrl: 'https://staging.backend.leadconnectorhq.com/reselling',
    reserveServiceBaseUrl: 'https://staging.backend.leadconnectorhq.com/reserve',
    restApiUrl: 'https://staging.backend.leadconnectorhq.com',
    saasServiceBaseUrl: 'https://backend.leadconnectorhq.com/saas_service', // production saas URL
    bladePlatformBaseUrl: 'https://staging.backend.leadconnectorhq.com/blade-platform',
    shortenUrlServiceUrl: 'https://url-shorten-dot-highlevel-backend.appspot.com/',
    smtpServiceUrl: 'https://smpt-service-269314.appspot.com/',
    snapshotServiceUrl: 'https://staging.backend.leadconnectorhq.com/snapshots-appengine',
    snapshotsRevexUrl: 'https://staging.backend.leadconnectorhq.com/snapshots',
    statsApiURL: 'http://localhost:5105',
    surveysApiUrl: 'https://stagingrest.gohighlevel.com',
    wordpress: {
      apiUrl: 'https://staging.backend.leadconnectorhq.com/wordpress',
    },
    dataBridgeApiUrl: 'https://staging.backend.leadconnectorhq.com/data-bridge',
    mediaServiceUrl: 'https://staging.backend.leadconnectorhq.com/medias',
  },
  staging: {
    agentReportingUrl: 'https://staging.backend.leadconnectorhq.com',
    attributionUrl: 'https://staging.backend.leadconnectorhq.com/attribution_service',
    baseUrl:
      process.env.DEV_ENV && apiUrls[process.env.DEV_ENV]
        ? apiUrls[process.env.DEV_ENV]
        : 'https://highlevel-staging.appspot.com',
    bulkActionURL: 'https://staging.services.leadconnectorhq.com/bulk-actions',
    bulkReqURL: 'https://bulk-request-dot-highlevel-staging.uc.r.appspot.com',
    cdnURL: 'https://staging.filesafe.space/',
    chatWidgetDeploymentUrl: 'https://storage.googleapis.com/staging-leadconnector/',
    cloudFunctionsUrl: 'https://us-central1-highlevel-staging.cloudfunctions.net',
    cnameRedirectURL: 'flash-funnel-staging.msgsndr.com',
    cnameWhitelabelURL: 'link.msgsndr.com',
    conversationsReportingServiceUrl: 'https://staging.backend.leadconnectorhq.com/conversations-reporting',
    conversationsServiceUrl: 'https://staging.backend.leadconnectorhq.com/conversations',
    deepLinkUrl: 'https://deep-link-dot-highlevel-staging.uc.r.appspot.com',
    dialogflowEngagementsBaseUrl: 'https://staging.backend.leadconnectorhq.com/dialogflow-engagement',
    emailReportingUrl: 'https://staging.backend.leadconnectorhq.com',
    emailsServiceUrl: 'https://staging.backend.leadconnectorhq.com/emails',
    formEmbedUrl: 'https://staging.link.gohighlevel.com/js',
    formsApiUrl: 'https://staging.backend.leadconnectorhq.com',
    formsApiUrlV1: 'https://stagingrest.gohighlevel.com',
    frontEndCNameRedirectURL: 'staging.msgsndr.com',
    funnelsApiURL: 'https://staging.backend.leadconnectorhq.com',
    funnelServiceBaseUrl: 'https://staging.backend.leadconnectorhq.com/funnel_backend',
    ghlRevexBackendUrl: 'https://staging.backend.leadconnectorhq.com/phone-system',
    humanRollOverServiceBaseUrl: 'https://staging.backend.leadconnectorhq.com/eliza',
    isvServiceBaseUrl: 'https://staging.backend.leadconnectorhq.com/isv_service',
    localizationApiURL: 'https://staging.backend.leadconnectorhq.com/localization',
    globalSearchApiURL: 'https://staging.backend.leadconnectorhq.com/global-search',
    membershipUrl: 'https://staging.backend.leadconnectorhq.com/membership',
    communitiesUrl: 'https://staging.backend.leadconnectorhq.com/communities',
    membershipAppUrl: 'https://staging.backend.memberships.apisystem.tech',
    newBaseUrl: 'https://staging.backend.leadconnectorhq.com/appengine',
    newMembershipUrl: 'https://backend.leadconnectorhq.com/membership', // used url from development override condition
    oldBaseUrl: 'https://staging.services.leadconnectorhq.com/appengine',
    opportunityReportingService: 'https://staging.backend.leadconnectorhq.com/reporting/opportunities',
    paymentsApiURL: 'https://staging.backend.leadconnectorhq.com',
    paymentServiceBaseUrl: 'https://staging.backend.leadconnectorhq.com/payment_service',
    phoneCallReportingService: 'https://staging.backend.leadconnectorhq.com/phone_call_reporting',
    productsApiURL: 'https://staging.backend.leadconnectorhq.com',
    publicApiUrl: 'https://public-api-dot-highlevel-staging.uc.r.appspot.com',
    pythonBaseUrl: 'https://python-backend-dot-highlevel-staging.appspot.com',
    reputation: {
      apiUrl: 'https://staging.backend.leadconnectorhq.com/reputation',
    },
    requestLoggerApiURL: 'https://staging.backend.leadconnectorhq.com',
    resellingBaseUrl: 'https://staging.backend.leadconnectorhq.com/reselling',
    reserveServiceBaseUrl: 'https://staging.backend.leadconnectorhq.com/reserve',
    restApiUrl: 'https://staging.backend.leadconnectorhq.com',
    saasServiceBaseUrl: 'https://staging.backend.leadconnectorhq.com/saas_service',
    bladePlatformBaseUrl: 'https://staging.backend.leadconnectorhq.com/blade-platform',
    shortenUrlServiceUrl: 'https://url-shorten-dot-highlevel-staging.appspot.com/',
    smtpServiceUrl: 'https://smpt-service-269314.appspot.com/',
    snapshotServiceUrl: 'https://staging.backend.leadconnectorhq.com/snapshots-appengine',
    snapshotsRevexUrl: 'https://staging.backend.leadconnectorhq.com/snapshots', // used url from development object
    statsApiURL: 'https://staging.backend.leadconnectorhq.com',
    surveysApiUrl: 'https://stagingrest.gohighlevel.com',
    wordpress: {
      apiUrl: 'https://staging.backend.leadconnectorhq.com/wordpress',
    },
    dataBridgeApiUrl: 'https://staging.backend.leadconnectorhq.com/data-bridge',
    mediaServiceUrl: 'https://staging.backend.leadconnectorhq.com/medias',
  },
  interop: {
    agentReportingUrl: 'https://interop.backend.leadconnectorhq.com',
    attributionUrl: 'https://interop.backend.leadconnectorhq.com/attribution_service',
    baseUrl:
      process.env.DEV_ENV && apiUrls[process.env.DEV_ENV]
        ? apiUrls[process.env.DEV_ENV]
        : 'https://highlevel-staging.appspot.com',
    bulkActionURL: 'https://interop.services.leadconnectorhq.com/bulk-actions',
    bulkReqURL: 'https://bulk-request-dot-highlevel-staging.uc.r.appspot.com',
    cdnURL: 'https://interop.filesafe.space/',
    chatWidgetDeploymentUrl: 'https://storage.googleapis.com/staging-leadconnector/',
    cloudFunctionsUrl: 'https://us-central1-highlevel-staging.cloudfunctions.net',
    cnameRedirectURL: 'flash-funnel-interop.msgsndr.com',
    cnameWhitelabelURL: 'link.msgsndr.com',
    conversationsReportingServiceUrl: 'https://interop.backend.leadconnectorhq.com/conversations-reporting',
    conversationsServiceUrl: 'https://interop.backend.leadconnectorhq.com/conversations',
    deepLinkUrl: 'https://deep-link-dot-highlevel-staging.uc.r.appspot.com',
    dialogflowEngagementsBaseUrl: 'https://interop.backend.leadconnectorhq.com/dialogflow-engagement',
    emailReportingUrl: 'https://interop.backend.leadconnectorhq.com',
    emailsServiceUrl: 'https://interop.backend.leadconnectorhq.com/emails',
    formEmbedUrl: 'https://staging.link.gohighlevel.com/js',
    formsApiUrl: 'https://interop.backend.leadconnectorhq.com',
    formsApiUrlV1: 'https://stagingrest.gohighlevel.com',
    frontEndCNameRedirectURL: 'staging.msgsndr.com',
    funnelsApiURL: 'https://interop.backend.leadconnectorhq.com',
    funnelServiceBaseUrl: 'https://interop.backend.leadconnectorhq.com/funnel_backend',
    ghlRevexBackendUrl: 'https://interop.backend.leadconnectorhq.com/phone-system',
    globalSearchApiURL: 'https://interop.backend.leadconnectorhq.com/global-search',
    humanRollOverServiceBaseUrl: 'https://interop.backend.leadconnectorhq.com/eliza',
    isvServiceBaseUrl: 'https://interop.backend.leadconnectorhq.com/isv_service',
    localizationApiURL: 'https://interop.backend.leadconnectorhq.com/localization',
    membershipUrl: 'https://interop.backend.leadconnectorhq.com/membership',
    communitiesUrl: 'https://interop.backend.leadconnectorhq.com/communities',
    membershipAppUrl: 'https://staging.backend.memberships.apisystem.tech',
    newBaseUrl: 'https://interop.backend.leadconnectorhq.com/appengine',
    newMembershipUrl: 'https://backend.leadconnectorhq.com/membership', // used url from development override condition
    oldBaseUrl: 'https://interop.services.leadconnectorhq.com/appengine',
    opportunityReportingService: 'https://interop.backend.leadconnectorhq.com/reporting/opportunities',
    paymentsApiURL: 'https://interop.backend.leadconnectorhq.com',
    paymentServiceBaseUrl: 'https://interop.backend.leadconnectorhq.com/payment_service',
    phoneCallReportingService: 'https://interop.backend.leadconnectorhq.com/phone_call_reporting',
    productsApiURL: 'https://interop.backend.leadconnectorhq.com',
    publicApiUrl: 'https://public-api-dot-highlevel-staging.uc.r.appspot.com',
    pythonBaseUrl: 'https://python-backend-dot-highlevel-staging.appspot.com',
    reputation: {
      apiUrl: 'https://interop.backend.leadconnectorhq.com/reputation',
    },
    requestLoggerApiURL: 'https://interop.backend.leadconnectorhq.com',
    resellingBaseUrl: 'https://interop.backend.leadconnectorhq.com/reselling',
    reserveServiceBaseUrl: 'https://interop.backend.leadconnectorhq.com/reserve',
    restApiUrl: 'https://interop.backend.leadconnectorhq.com',
    saasServiceBaseUrl: 'https://interop.backend.leadconnectorhq.com/saas_service',
    bladePlatformBaseUrl: 'https://interop.backend.leadconnectorhq.com/blade-platform',
    shortenUrlServiceUrl: 'https://url-shorten-dot-highlevel-staging.appspot.com/',
    smtpServiceUrl: 'https://smpt-service-269314.appspot.com/',
    snapshotServiceUrl: 'https://interop.backend.leadconnectorhq.com/snapshots-appengine',
    snapshotsRevexUrl: 'https://interop.backend.leadconnectorhq.com/snapshots', // used url from development object
    statsApiURL: 'https://interop.backend.leadconnectorhq.com',
    surveysApiUrl: 'https://stagingrest.gohighlevel.com',
    wordpress: {
      apiUrl: 'https://interop.backend.leadconnectorhq.com/wordpress',
    },
    dataBridgeApiUrl: 'https://interop.backend.leadconnectorhq.com/data-bridge',
    mediaServiceUrl: 'https://interop.backend.leadconnectorhq.com/medias',
  },
  beta: {
    agentReportingUrl: 'https://beta.backend.leadconnectorhq.com',
    attributionUrl: 'https://beta.backend.leadconnectorhq.com/attribution_service',
    baseUrl: 'https://beta-dot-highlevel-backend.appspot.com',
    bulkActionURL: 'https://beta.backend.leadconnectorhq.com/bulk-actions',
    bulkReqURL: 'https://bulk-request-dot-highlevel-backend.uc.r.appspot.com',
    cdnURL: 'https://staging.filesafe.space/',
    chatWidgetDeploymentUrl: 'https://widgets.leadconnectorhq.com/',
    cloudFunctionsUrl: 'https://us-central1-highlevel-backend.cloudfunctions.net',
    cnameRedirectURL: 'flash.funnels.msgsndr.com',
    cnameWhitelabelURL: 'link.msgsndr.com',
    conversationsReportingServiceUrl: 'https://beta.backend.leadconnectorhq.com/conversations-reporting',
    conversationsServiceUrl: 'https://beta.backend.leadconnectorhq.com/conversations',
    deepLinkUrl: 'https://deep-link-dot-highlevel-backend.uc.r.appspot.com',
    dialogflowEngagementsBaseUrl: 'https://beta.backend.leadconnectorhq.com/dialogflow-engagement',
    emailReportingUrl: 'https://beta.backend.leadconnectorhq.com',
    emailsServiceUrl: 'https://beta.backend.leadconnectorhq.com/emails',
    formEmbedUrl: 'https://link.gohighlevel.com/js/beta',
    formsApiUrl: 'https://beta.backend.leadconnectorhq.com', // used production url
    formsApiUrlV1: 'https://rest.gohighlevel.com', // used production url
    frontEndCNameRedirectURL: 'app.msgsndr.com',
    funnelServiceBaseUrl: 'https://beta.backend.leadconnectorhq.com/funnel_backend',
    ghlRevexBackendUrl: 'https://beta.backend.leadconnectorhq.com/phone-system',
    humanRollOverServiceBaseUrl: 'https://beta.backend.leadconnectorhq.com/eliza',
    isvServiceBaseUrl: 'https://beta.backend.leadconnectorhq.com/isv_service',
    localizationApiURL: 'https://beta.backend.leadconnectorhq.com/localization',
    membershipUrl: 'https://beta.backend.leadconnectorhq.com/membership',
    communitiesUrl: 'https://beta.backend.leadconnectorhq.com/communities',
    globalSearchApiURL: 'https://beta.backend.leadconnectorhq.com/global-search',
    membershipAppUrl: 'https://backend.memberships.apisystem.tech',
    newBaseUrl: 'https://beta.backend.leadconnectorhq.com/appengine',
    newMembershipUrl: 'https://beta.backend.leadconnectorhq.com/membership', // used production url
    oldBaseUrl: 'https://beta.services.leadconnectorhq.com/appengine',
    opportunityReportingService: 'https://beta.backend.leadconnectorhq.com/reporting/opportunities',
    paymentServiceBaseUrl: 'https://beta.backend.leadconnectorhq.com/payment_service',
    phoneCallReportingService: 'https://beta.backend.leadconnectorhq.com/phone_call_reporting',
    publicApiUrl: 'https://rest.gohighlevel.com',
    pythonBaseUrl: 'https://beta-dot-python-backend-dot-highlevel-backend.appspot.com',
    reputation: {
      apiUrl: 'https://beta.backend.leadconnectorhq.com/reputation',
    },
    resellingBaseUrl: 'https://beta.backend.leadconnectorhq.com/reselling',
    reserveServiceBaseUrl: 'https://beta.backend.leadconnectorhq.com/reserve',
    restApiUrl: 'https://beta.backend.leadconnectorhq.com',
    saasServiceBaseUrl: 'https://beta.backend.leadconnectorhq.com/saas_service',
    bladePlatformBaseUrl: 'https://beta.backend.leadconnectorhq.com/blade-platform',
    shortenUrlServiceUrl: 'https://url-shorten-dot-highlevel-backend.appspot.com/',
    smtpServiceUrl: 'https://smpt-service-269314.appspot.com/',
    snapshotServiceUrl: 'https://beta.backend.leadconnectorhq.com/snapshots-appengine',
    snapshotsRevexUrl: 'https://beta.backend.leadconnectorhq.com/snapshots',
    statsApiURL: 'https://beta.backend.leadconnectorhq.com',
    surveysApiUrl: 'https://rest.gohighlevel.com', // used production url
    wordpress: {
      apiUrl: 'https://beta.backend.leadconnectorhq.com/wordpress',
    },
    dataBridgeApiUrl: 'https://beta.backend.leadconnectorhq.com/data-bridge',
    mediaServiceUrl: 'https://beta.backend.leadconnectorhq.com/medias',
  },
  production: {
    agentReportingUrl: 'https://backend.leadconnectorhq.com',
    attributionUrl: 'https://backend.leadconnectorhq.com/attribution_service',
    baseUrl: 'https://api.leadconnectorhq.com',
    bulkActionURL: 'https://backend.leadconnectorhq.com/bulk-actions',
    bulkReqURL: 'https://api.leadconnectorhq.com',
    cdnURL: 'https://assets.cdn.filesafe.space/',
    chatWidgetDeploymentUrl: 'https://widgets.leadconnectorhq.com/',
    cloudFunctionsUrl: 'https://us-central1-highlevel-backend.cloudfunctions.net',
    cnameRedirectURL: 'flash.funnels.msgsndr.com',
    cnameWhitelabelURL: 'link.msgsndr.com',
    conversationsReportingServiceUrl: 'https://backend.leadconnectorhq.com/conversations-reporting',
    conversationsServiceUrl: 'https://backend.leadconnectorhq.com/conversations',
    deepLinkUrl: 'https://deep-link-dot-highlevel-backend.uc.r.appspot.com',
    dialogflowEngagementsBaseUrl: 'https://backend.leadconnectorhq.com/dialogflow-engagement',
    emailReportingUrl: 'https://backend.leadconnectorhq.com',
    emailsServiceUrl: 'https://backend.leadconnectorhq.com/emails',
    formEmbedUrl: 'https://link.msgsndr.com/js',
    formsApiUrl: 'https://backend.leadconnectorhq.com',
    formsApiUrlV1: 'https://rest.gohighlevel.com',
    frontEndCNameRedirectURL: 'app.msgsndr.com',
    funnelServiceBaseUrl: 'https://backend.leadconnectorhq.com/funnel_backend',
    ghlRevexBackendUrl: 'https://backend.leadconnectorhq.com/phone-system',
    humanRollOverServiceBaseUrl: 'https://backend.leadconnectorhq.com/eliza',
    isvServiceBaseUrl: 'https://backend.leadconnectorhq.com/isv_service',
    localizationApiURL: 'https://backend.leadconnectorhq.com/localization',
    globalSearchApiURL: 'https://backend.leadconnectorhq.com/global-search',
    membershipUrl: 'https://backend.leadconnectorhq.com/membership',
    communitiesUrl: 'https://backend.leadconnectorhq.com/communities',
    membershipAppUrl: 'https://backend.memberships.apisystem.tech',
    newBaseUrl: 'https://backend.leadconnectorhq.com/appengine',
    newMembershipUrl: 'https://backend.leadconnectorhq.com/membership',
    oldBaseUrl: 'https://services.leadconnectorhq.com/appengine',
    opportunityReportingService: 'https://backend.leadconnectorhq.com/reporting/opportunities',
    paymentServiceBaseUrl: 'https://backend.leadconnectorhq.com/payment_service',
    phoneCallReportingService: 'https://backend.leadconnectorhq.com/phone_call_reporting',
    publicApiUrl: 'https://rest.gohighlevel.com',
    pythonBaseUrl: 'https://python-backend-dot-highlevel-backend.appspot.com',
    reputation: {
      apiUrl: 'https://backend.leadconnectorhq.com/reputation',
    },
    resellingBaseUrl: 'https://backend.leadconnectorhq.com/reselling',
    reserveServiceBaseUrl: 'https://backend.leadconnectorhq.com/reserve',
    restApiUrl: 'https://backend.leadconnectorhq.com',
    saasServiceBaseUrl: 'https://backend.leadconnectorhq.com/saas_service',
    bladePlatformBaseUrl:'https://backend.leadconnectorhq.com/blade-platform',
    shortenUrlServiceUrl: 'https://url-shorten-dot-highlevel-backend.appspot.com/',
    smtpServiceUrl: 'https://smpt-service-269314.appspot.com/',
    snapshotServiceUrl: 'https://backend.leadconnectorhq.com/snapshots-appengine',
    snapshotsRevexUrl: 'https://backend.leadconnectorhq.com/snapshots',
    statsApiURL: 'https://backend.leadconnectorhq.com',
    surveysApiUrl: 'https://rest.gohighlevel.com',
    wordpress: {
      apiUrl: 'https://backend.leadconnectorhq.com/wordpress',
    },
    dataBridgeApiUrl: 'https://backend.leadconnectorhq.com/data-bridge',
    mediaServiceUrl: 'https://backend.leadconnectorhq.com/medias',
  },
}

const backendURLs = config[override ? 'production' : process.env.NODE_ENV as keyof typeof config]

if (process.env.NODE_ENV === 'development' && !override) {
  backendURLs.agentReportingUrl = 'http://localhost:5020'
  backendURLs.attributionUrl = 'https://staging.backend.leadconnectorhq.com/attribution_service'
  backendURLs.dialogflowEngagementsBaseUrl = 'http://localhost:5050'
  backendURLs.emailReportingUrl = 'http://localhost:5010'
  backendURLs.funnelServiceBaseUrl = 'http://localhost:5030/funnel_backend'
  backendURLs.humanRollOverServiceBaseUrl = 'http://localhost:5020/eliza'
  backendURLs.isvServiceBaseUrl = 'https://staging.backend.leadconnectorhq.com/isv_service'
  backendURLs.membershipUrl = 'https://staging.backend.leadconnectorhq.com/membership'
  backendURLs.newMembershipUrl = 'http://localhost:7000'
  backendURLs.opportunityReportingService = 'http://localhost:6010/reporting/opportunities'
  backendURLs.phoneCallReportingService = 'http://localhost:5010/phone_call_reporting'
  backendURLs.pythonBaseUrl = 'https://python-backend-dot-highlevel-staging.appspot.com'
  backendURLs.saasServiceBaseUrl = 'https://staging.backend.leadconnectorhq.com/saas_service'
  backendURLs.bladePlatformBaseUrl = 'https://staging.backend.leadconnectorhq.com/blade-platform'
  backendURLs.shortenUrlServiceUrl = 'https://url-shorten-dot-highlevel-staging.appspot.com/'
  // backendURLs.localizationApiURL = 'http://localhost:5075/localization'
  // backendURLs.globalSearchApiURL = 'http://localhost:5097/global-search'

  switch (process.env.VUE_APP_DEV_TEAM) {
    case 'payments':
      backendURLs.productsApiURL = 'http://localhost:5053'
      backendURLs.paymentsApiURL = 'http://localhost:5055'
      backendURLs.requestLoggerApiURL = 'http://localhost:5067'
      backendURLs.funnelsApiURL = 'http://localhost:5054'
      backendURLs.statsApiURL = 'http://localhost:5105'
      break
    case 'snapshots':
      backendURLs.baseUrl = 'http://localhost:5000'
      backendURLs.newBaseUrl = 'http://localhost:5000'
      break
  }
}

export default backendURLs
